export default __webpack_public_path__ + "static/media/2079_01 drawing.69c734b4.gif";